export function validQuantity(value) {
    return value === '' || (/^\d+$/.test(String(value)) && Number.isSafeInteger(Number(value)) && Number(value) > 0);
}

export function buildQuoteUrl(model = '', quantity = '') {
    var message = model ? 'Hola, quiero cotizar el guante ' + model + '.' : 'Hola, quiero cotizar guantes para mi equipo.';
    if (quantity !== '' && validQuantity(quantity)) message += ' Cantidad: ' + quantity + ' pares.';
    if (!model) message += ' ¿Me ayudan a elegir un modelo?';
    return 'https://wa.me/524311032726?text=' + encodeURIComponent(message);
}

export function bindQuoteLinks(model, quantity, links) {
    function update() {
        quantity.setCustomValidity('');
        var name = typeof model === 'string' ? model : model.value;
        links.forEach(function (link) { link.href = buildQuoteUrl(name, quantity.value); });
    }
    quantity.addEventListener('input', update);
    if (typeof model !== 'string') model.addEventListener('change', update);
    links.forEach(function (link) {
        link.addEventListener('click', function (event) {
            quantity.setCustomValidity(validQuantity(quantity.value) ? '' : 'Ingresa una cantidad entera mayor que cero.');
            if (!quantity.reportValidity()) event.preventDefault();
        });
    });
    update();
    return update;
}

export function initQuoteForm() {
    var form = /** @type {HTMLFormElement | null} */ (document.getElementById('contact-form'));
    if (!form) return;
    var model = /** @type {HTMLSelectElement} */ (form.elements.namedItem('model'));
    var quantity = /** @type {HTMLInputElement} */ (form.elements.namedItem('quantity'));
    var update = bindQuoteLinks(model, quantity, form.querySelectorAll('.quote-contact-link'));
    form.addEventListener('reset', function () { setTimeout(update, 0); });
}
